export enum IDocVisibilityOptionEnum {
  DRAFT_QUOTATION = 'DRAFT_QUOTATION',
  DEFINITIVE_QUOTATION = 'DEFINITIVE_QUOTATION',
  SALES_ORDER = 'SALES_ORDER',
  SALES_INVOICE = 'SALES_INVOICE',
  PURCHASE_ORDER = 'PURCHASE_ORDER',
}
